module.exports = __webpack_public_path__ + "img/chinesecompany208.5a9b7eaf.png";